// src/components/Header.js
import React, { useState } from "react";
import logo from "../../assets/logo1.png";
import { Menu, X } from "lucide-react";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="bg-white shadow-xl border-b border-gray-200 w-full z-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-28"> 
          {/* ⬆ Increased height (was h-20, now h-28) */}

          {/* Left: Logo */}
          <div className="flex items-center space-x-4">
            <img
              className="h-20 md:h-24" // ⬆ Increased logo size
              src={logo}
              alt="Butterfly Groups"
            />
          </div>

          {/* Right: Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6 text-lg text-[#204356] font-medium">
            <a href="/#" className="hover:text-[#005CA8]">Home</a>
            <a href="/about" className="hover:text-[#005CA8]">About Us</a>
            <a href="/wellness" className="hover:text-[#005CA8]">Wellness</a>
            <a href="/purepower" className="hover:text-[#005CA8]">PuRE Power</a>
            <a href="https://butterflyhrglobal.com/job-vacancies" className="hover:text-[#005CA8]">Careers</a>
            <a
              href="/contact"
              className="px-5 py-3 bg-[#005CA8] text-white rounded-md hover:bg-blue-700 transition"
            >
              Contact us
            </a>
          </nav>

          {/* Mobile Hamburger Button */}
          <button
            className="md:hidden text-[#204356] focus:outline-none"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={32} /> : <Menu size={32} />} 
            {/* ⬆ Larger icon size */}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-md">
          <nav className="flex flex-col space-y-5 p-6 text-lg text-[#204356] font-medium">
            <a href="/#" className="hover:text-[#005CA8]">Home</a>
            <a href="/about" className="hover:text-[#005CA8]">About Us</a>
            <a href="/wellness" className="hover:text-[#005CA8]">Wellness</a>
            <a href="/purepower" className="hover:text-[#005CA8]">PuRE Power</a>
            <a href="/career" className="hover:text-[#005CA8]">Careers</a>
            <a
              href="#contact"
              className="px-5 py-3 bg-[#005CA8] text-white rounded-md hover:bg-blue-700 transition text-center"
            >
              Contact us
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
